<div class="listing-card"
  (click)="onCardClick()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div class="card-image-container">
    <!-- Image carousel implementation -->
    <div class="carousel-container">
      <div class="carousel-images">
        @for (image of listing.images; track image; let i = $index) {
          <img
            [src]="formatImageUrl(image)"
            class="card-image"
            alt="{{listing.title}} - Image {{i+1}}"
            [class.active]="currentImageIndex === i">
        }
      </div>

      <!-- Previous button on left -->
      @if (listing.images?.length > 1) {
        <button class="carousel-control prev"
          (click)="prevImage(); $event.stopPropagation()"
          >
          <span class="control-icon">&#10094;</span>
        </button>
      }

      <!-- Next button on right -->
      @if (listing.images?.length > 1) {
        <button class="carousel-control next"
          (click)="nextImage(); $event.stopPropagation()"
          >
          <span class="control-icon">&#10095;</span>
        </button>
      }

      <!-- Image indicators -->
      @if (listing.images?.length > 1) {
        <div class="carousel-indicators" (click)="$event.stopPropagation()">
          @for (image of listing.images; track image; let i = $index) {
            <span
              class="indicator"
              [class.active]="currentImageIndex === i"
            (click)="setCurrentImage(i)"></span>
          }
        </div>
      }
    </div>

    @if (listing.offerDesc && !listing.soldOut) {
      <div class="offer-badge">{{listing.offerDesc}}</div>
    }
    @if (listing.soldOut) {
      <div class="offer-badge">Leased - N/A</div>
    }

  </div>

  <div class="card-content">
    <h3 class="card-title">{{listing.title}}</h3>
    <div class="card-details">
      <span class="listing-id">Listing # {{listing.listingId}}</span>
      <span class="acres-info">{{listing.acres}} Acres</span>
    </div>

    <!-- Added description here for better mobile visibility -->
    @if (offerDesc) {
      <div class="card-description">
        <p [innerHTML]="offerDesc | safeHtml"></p>
      </div>
    }

    <div class="activities-container">
      @for (a of listing.activities; track a) {
        <span class="activity-icon-wrapper">
          <img [src]="formatActivityImg(a)" class="activity-icon" [title]="a.name" alt="{{a.name}}"/>
        </span>
      }
    </div>
  </div>
</div>
